import React, { useEffect } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { isAfter } from 'date-fns';

import KogKeyboardDatePicker from '@/main/components/shared/datepicker/keyboardDatePicker';
import { getDateNowTimeZoneUser, isDateValid, onLoadDateRangePicker } from '@/main/services/utilsDate';
import { GeneralVariableType, useDynamicFiltersExport } from './dynamicFiltersExport';

interface IVariableTypeDateProps extends GeneralVariableType { }
function VariableTypeDate({
  filter
}: IVariableTypeDateProps) {
  const CURRENT_DATE = getDateNowTimeZoneUser().setUTCHours(23, 59, 59, 999);
  const {
    keyReducer,
    findFieldIndexByGuidDynamicReportVariable,
    idScreen,
    watcherCountry
  } = useDynamicFiltersExport();
  const {
    control,
    resetField,
    setValue
  } = useFormContext();
  const indexField = findFieldIndexByGuidDynamicReportVariable(filter.guidDynamicReportVariable);

  const valueWatcher = useWatch({
    control,
    name: `filtersDinamics.${indexField}.value`,
    defaultValue: null
  });

  function validateDate() {
    const OBJ_VALIDATIONS_DATE: Record<string, boolean> = {
      isInvalidStartDate: !isDateValid(valueWatcher),
      finalDateGreaterThanCurrentDate: isAfter(valueWatcher, CURRENT_DATE),
    };

    const keysValidations = Object.keys(OBJ_VALIDATIONS_DATE);
    const keysError = keysValidations.find(key => OBJ_VALIDATIONS_DATE[key]);

    return !!keysError;
  }


  useEffect(() => {
    const { firstDateResult, secondDateResult } = onLoadDateRangePicker(0);
    setValue(`filtersDinamics.${indexField}.value`, secondDateResult);
  }, []);

  return (
    <>
      <Controller
        name={`filtersDinamics.${indexField}.value`}
        defaultValue={new Date()}
        rules={{}}
        control={control}
        render={({
          field: { name, value, ...restField },
          fieldState: { error }
        }) => (
          <KogKeyboardDatePicker
            isFieldInModal
            fullWidth
            hasBackground
            required={filter.responseServer.mandatory}
            id={idScreen(name)}
            name={name}
            value={value}
            label={filter.responseServer.filterName}
            error={validateDate() || !!error}
            disabled={false}
            onChange={date => {
              restField.onChange(date);
            }}
          />
        )}
      />
    </>
  )
}

export default VariableTypeDate